<style scoped lang="scss">

</style>



<template>
    <div>
        <div class="uk-form" v-if="application">
            <div class="uk-container">
                <div class="uk-grid">
                    <div class="uk-width-1-1">
                        <h3><!-- hide this message if a message from the processor is being displayed -->
                            We have identified the following documents that you need to provide as a part of your application. Until these documents are all received, we cannot process your application. To help expedite this process, you can upload copies of your documents.</h3>
                        <div class="uk-panel-box">
                            <p>Methods in which you can upload a document:</p>
                            <ul>
                                <li>Login on your mobile device and use the camera feature to capture and upload documents.</li>
                                <li>Upload saved JPG, PNG, or PDF formats.</li>
                                <li>Save a copy of the document as a PDF then upload the file.</li>
                                <li>Print, scan then upload a document.</li>
                            </ul>

                            <p>
                                If you do not have a copy of your lease, and / or your landlord is unwilling to participate. Please download and complete a self attestation form and provide it in the place of your lease.
                            </p>

                            <div v-if="!programSettings['uses-upload-only-package-submission']">
                                <p>If you don't have access to any of the above methods to upload a copy of your documents, you can also:</p>
                                <ul style="list-style:none;">
                                    <li style="margin-left:-1em;"><i class="uk-icon-fax" style="margin-right:.5em;"></i> FAX a copy of your documents to us.</li>
                                    <li style="margin-left:-1em;;"><i class="uk-icon-truck" style="margin-right:.5em;"></i> Mail a copy of your documents to us.</li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="uk-width-1-1 uk-margin-large-bottom uk-margin-large-top ">
                    <blockquote class="">Please let us know how you will provide the following required documents:</blockquote>
                </div>

                <!-- Repeat this region for each applicant -->
                <div class="uk-width-1-1 uk-margin-large-bottom" v-for="member in membersWithRequests" v-if="!programSettings['uses-upload-only-package-submission']">
                <!--<div class="uk-width-1-1 uk-margin-large-bottom" v-for="member in membersWithRequests" >-->
                    <div class="uk-grid">
                        <div class="uk-width-1-1 uk-width-medium-1-2 uk-text-medium">
                            <h3>Documents for {{ member.first_name }} {{ member.last_name }} <span class="uk-visible-small">provided by (select one).</span></h3>
                        </div>
                        <div class="uk-width-1-2 uk-hidden-small uk-text-medium"><strong>Provided by:</strong></div>
                        <div class="uk-width-1-1 uk-margin-top-remove">
                            <hr class="uk-width-1-1 uk-grid-divider uk-margin-top-remove">
                        </div>
                    </div>
                    <div v-if="showDeliveryMethodNotification(member)" class="uk-text-danger italic uk-margin-bottom">Using this method of document delivery may significantly delay your application's processing.</div>
                    <!-- Repeat this region for each document the applicant must provide -->
                    <div class="uk-panel uk-panel-hAover ">
                        <div class="uk-grid" v-for="request in documentRequestsForMember(member)">
                            <div class="uk-width-1-1 uk-width-medium-1-2">
                                <div class="category-name"><strong>{{ request.category.document_category_name }}</strong></div>
                                <div class="details">{{ request.details }}</div>
                                <span v-if="request.required"> (Required)</span>
                            </div>
                            <div class="uk-width-1-1  uk-width-medium-1-2">
                                <label>
                                    <input type="radio" v-model="request.delivery_method" @change="updateDelivery(request, 'upload')" value="upload">
                                    <i class="uk-icon-cloud-upload"></i>&nbsp;Upload</label>

                                <label>
                                    <input type="radio" v-model="request.delivery_method" @change="updateDelivery(request, 'fax')" value="fax">
                                    <i class="uk-icon-fax"></i>&nbsp;FAX
                                </label>

                                <label>
                                    <input type="radio" v-model="request.delivery_method" @change="updateDelivery(request, 'mail')" value="mail">
                                    <i class="uk-icon-truck"></i>&nbsp;Mail
                                </label>

                                <label>
                                    <input type="radio" v-model="request.delivery_method" @change="updateDelivery(request, 'notapplicable')" value="notapplicable">
                                    <i class="uk-icon-ban"></i>&nbsp;Not Applicable
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- insert divider between instances -->
                </div>
            </div>

            <div class="uk-container" v-if="allMethodsChosen">
                <div class="uk-grid">
                    <div class="uk-width-1-1">
                        <h2>Upload Documents</h2>
                        <div class="uk-grid" v-for="req in uploadDocumentRequests">
                            <div class="uk-width-9-10 uk-align-center" style="padding-left: 72px;">
                                <validated-section :errors="errors" :field="getDocRequestErrorKey(req)"></validated-section>
                            </div>
                            <document-request-category-upload :ref="'request_'+req.id" :request="req"></document-request-category-upload>

                        </div>
                        <hr class="uk-width-1-1 uk-grid-divider">
                    </div>


                    <div class="uk-width-1-1" v-if="emailDocumentRequests.length > 0">
                        <h2>Email Documents</h2>
                        <div class="uk-grid" v-for="request in emailDocumentRequests">
                            <div class="uk-width-9-10 uk-align-center document-container uk-flex">
                                <h4>
                                    <i class="uk-icon-file"></i>
                                    {{ request.category.document_category_name }}
                                    <span style="font-size: 0.9em; color: #999;"> | {{ request.household_member.first_name }} {{ request.household_member.last_name }}</span>
                                </h4>

                            </div>
                        </div>
                        <div class="uk-width-9-10 uk-align-center">
                            <button class="uk-button uk-button-primary uk-button-large uk-margin-top" @click="printEmailManifest">View / Print Email Instructions</button>
                        </div>

                        <email-manifest
                                :application="application"
                                :requests="emailDocumentRequests"
                                style="display: none;"
                                id="email-manifest"></email-manifest>
                        <hr class="uk-width-1-1 uk-grid-divider">
                    </div>



                    <div class="uk-width-1-1" v-if="mailDocumentRequests.length > 0">
                        <h2>Mail Documents</h2>
                        <div class="uk-grid" v-for="request in mailDocumentRequests">
                            <div class="uk-width-9-10 uk-align-center document-container uk-flex">
                                <h4>
                                    <i class="uk-icon-file"></i>
                                    {{ request.category.document_category_name }}
                                    <span style="font-size: 0.9em; color: #999;"> | {{ request.household_member.first_name }} {{ request.household_member.last_name }}</span>
                                </h4>

                            </div>
                        </div>
                        <div class="uk-width-9-10 uk-align-center">
                            <button class="uk-button uk-button-primary uk-button-large uk-margin-top" @click="printMailManifest">Print Mail Cover Sheet</button>
                        </div>

                        <snail-mail-manifest
                                :application="application"
                                :applicant="applicant"
                                :requests="mailDocumentRequests"
                                style="display: none;"
                                id="snail-mail-manifest"></snail-mail-manifest>
                        <hr class="uk-width-1-1 uk-grid-divider">
                    </div>



                    <div class="uk-width-1-1" v-if="faxDocumentRequests.length > 0">
                        <h2>Fax Documents</h2>
                        <div class="uk-grid" v-for="request in faxDocumentRequests">
                            <div class="uk-width-9-10 uk-align-center document-container uk-flex">
                                <h4>
                                    <i class="uk-icon-file"></i>
                                    {{ request.category.document_category_name }}
                                    <span style="font-size: 0.9em; color: #999;"> | {{ request.household_member.first_name }} {{ request.household_member.last_name }}</span>
                                </h4>

                            </div>
                        </div>
                        <div class="uk-width-9-10 uk-align-center">
                            <button class="uk-button uk-button-primary uk-button-large uk-margin-top" @click="printFaxManifest">Print Fax Cover Sheet</button>
                        </div>

                        <fax-manifest
                                :application="application"
                                style="display: none;"
                                :requests="faxDocumentRequests"
                                :applicant="applicant"
                                id="fax-manifest"></fax-manifest>
                        <hr class="uk-width-1-1 uk-grid-divider">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import VueUploadComponent from 'vue-upload-component';
    import DocumentRequestCategoryUpload from "../../../../../components/AppWizard/Documents/DocumentRequestCategoryUpload";
    import EmailManifest from "../../../../../components/AppWizard/Documents/EmailManifest";
    import SnailMailManifest from "../../../../../components/AppWizard/Documents/SnailMailManifest";
    import FaxManifest from "../../../../../components/AppWizard/Documents/FaxManifest";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    export default {
        name: "Step8",
        components: {
            ValidatedSection,
            FaxManifest, SnailMailManifest, EmailManifest, DocumentRequestCategoryUpload, VueUploadComponent},
        data() {
            return {
                showDeliveryMethodAlert: true,
                errors: {},
            }
        },
        computed: {
            unassignedDocuments() {
                return _.filter(this.documents, doc => doc.household_application_document_request_id === null);
            },
            uploadDocumentRequests() {
                let requests = _.filter(this.documentRequests, doc => doc.delivery_method === 'upload');
                return requests;
            },
            emailDocumentRequests() {
                let requests = _.filter(this.documentRequests, doc => doc.delivery_method === 'email');
                return requests;
            },
            faxDocumentRequests() {
                let requests = _.filter(this.documentRequests, doc => doc.delivery_method === 'fax');
                return requests;
            },
            mailDocumentRequests() {
                let requests = _.filter(this.documentRequests, doc => doc.delivery_method === 'mail');
                return requests;
            },
            allMethodsChosen() {
                let allChosen = true;
                _.each(this.documentRequests, req => {
                    if(req.method === null) {
                        allChosen = false;
                    }
                });
                return allChosen;
            },
            adultHouseholdMembers() {
                let members = [];
                if(!this.application) return [];
                if(this.application.household) {
                    _.each(this.application.household.members, member => {
                        if(member.age < 18) return;
                        members.push(member);
                    })
                }
                return members;
            },

            membersWithRequests() {
                let members = [];
                if(!this.application) return [];
                return _.filter(this.application.household.members, member => {
                    return this.documentRequestsForMember(member).length > 0;
                });
            },

            ...mapState('Application', {
                application: state => state.application,
                documentRequests: state => state.documentRequests,
                documents: state => state.documents,
                applicant: state=> state.applicant,
                programSettings: state => state.application.program.settings,
            }),
            ...mapGetters('Application', [ 'programSettings' ]),
        },
        methods: {
            showDeliveryMethodNotification(member) {
                return this.documentRequestsForMember(member).find(item => ['fax', 'mail'].includes(item.delivery_method))
            },

            documentsForCategory(categoryId) {
                return _.filter(this.documents, doc => {
                    let inCategory = false;
                    _.each(doc.categories, cat => {
                        if(cat.id == categoryId) {
                            inCategory = true;
                        }
                    });
                    return inCategory;
                });
            },
            updateDelivery(request, method) {
                if (['fax', 'mail'].includes(method) && this.showDeliveryMethodAlert)
                {
                    UIkit.modal.alert('Using this method of document delivery may significantly delay your application\'s processing.');
                    this.showDeliveryMethodAlert = false
                }
                axios.put(`/api/hope/application/${this.application.id}/document-requests/${request.id}`, {
                    delivery_method: method
                }).then(r => console.log);
            },
            documentRequestsForMember(member) {
                return _.filter(this.documentRequests, req => req.household_member_id == member.id);
            },

            printEmailManifest() {
                this.$htmlToPaper('email-manifest', {
                    autoPrint: false,
                })
            },
            printMailManifest() {
                this.$htmlToPaper('snail-mail-manifest', {
                    autoPrint: true,
                })
            },
            printFaxManifest() {
                this.$htmlToPaper('fax-manifest', {
                    autoPrint: true,
                })
            },
            getDocRequestErrorKey(req) {
                if (req.category)
                    return 'errors_' + req.category.key
                return
                    return 'errors_' + req.id
            },
            async validateStep() {
                console.log('resetting errors');
                this.errors = {}
                let stepValid = true

                _.each(this.documentRequests, (req) => {
                    let cmp = this.$refs['request_'+req.id];
                    if(cmp) {
                        let count = cmp[0].getDocumentCount();
                        if(count === 0) {
                            if (req.category && req.category.key === 'income-proof' && this.programSettings['uses-esign'])
                                return true
                            this.errors[this.getDocRequestErrorKey(req)] = { errors: ['You must upload a document for this section before continuing.']}
                        }
                    }

                })

                this.$nextTick(this.$forceUpdate);

                let errorCount = _.size(this.errors);

                if(errorCount > 0) stepValid = false;

                return stepValid;
            }
        }
    }
</script>
